import { Paper, Switch, Typography } from "@mui/material";
import type { NavigationMode } from "../../hooks/useLogbookEntries";

type Props = {
	mode: NavigationMode;
	onChange: (mode: NavigationMode) => void;
};

// Same Period / Shift switch card as the rbd-mill Stops Manager, at the height of
// the navigator date boxes next to it so the whole row reads as one line of controls
const FIELD_HEIGHT = 33;

export const NavigationModeSwitch = ({ mode, onChange }: Props) => (
	<Paper
		elevation={2}
		sx={{
			display: "flex",
			alignItems: "center",
			gap: 0.5,
			px: 1.5,
			py: 0,
			height: FIELD_HEIGHT,
			flexShrink: 0,
			userSelect: "none",
		}}
	>
		<Typography
			variant="body2"
			onClick={() => onChange("period")}
			sx={{
				cursor: "pointer",
				fontWeight: 600,
				color: mode === "period" ? "primary.main" : "text.secondary",
			}}
		>
			Period
		</Typography>
		<Switch
			checked={mode === "shift"}
			onChange={() => onChange(mode === "shift" ? "period" : "shift")}
			size="small"
		/>
		<Typography
			variant="body2"
			onClick={() => onChange("shift")}
			sx={{
				cursor: "pointer",
				fontWeight: 600,
				color: mode === "shift" ? "primary.main" : "text.secondary",
			}}
		>
			Shift
		</Typography>
	</Paper>
);
